import React, { useContext } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useFeatureToggle } from '@ibinder/ui-common-hooks';
import { Config, usePageViewTracker } from '@ibinder/common-utils';
import {
  BinderContent,
  Heading1,
  Card,
  ContainerWithColor,
  AnimatedDiv,
  PageHeader
} from '@ibinder/common-frontend';
import { BINDER_COLOR, BINDER_NAME, getTabs } from '../placeholderData';
import BinderInformation from './binderInformation';
import { AdminBinderContext } from '../AdminLayout';

const StyledContainerWithColor = styled(ContainerWithColor)`
  width: 100%;
  height: 100%;
  margin: 0;
  z-index: 10;
  border-top: 0.0625rem solid transparent;
`;

const Layout = styled.div`
  display: flex;
  margin: 0.75rem 1rem;
  height: calc(100% - 1.5rem);

  @media (max-width: ${(props) => props.theme.devices.md}px) {
    flex-direction: column;
  }
  @media (max-width: ${(props) => props.theme.devices.sm}px) {
    margin: 0.5rem;
    height: calc(100% - 1rem);
  }
`;

const BinderContentLeft = styled(BinderContent)`
  width: 100%;

  margin-right: 1rem;
  @media (max-width: ${(props) => props.theme.devices.md}px) {
    margin-right: 0;
    margin-bottom: 0.75rem;
    min-height: auto;
    height: auto;
  }
  @media (max-width: ${(props) => props.theme.devices.sm}px) {
    margin-bottom: 0.5rem;
  }
`;

const BinderContentRight = styled(BinderContent)`
  width: 100%;
`;

const ContentRegister = styled.div`
  padding: 0 1rem;
`;

const RegisterCards = styled.div`
  margin-top: 1rem;
`;

const AdminLandingPage = ({ ...otherProps }) => {
  const { rightPanelOpen, toggleTabsMenu } = useContext(AdminBinderContext);
  const { isEnabled: showBatchOperations } = useFeatureToggle(
    'batchOperations',
    Config.OPERATIONAL_CONFIG
  );
  usePageViewTracker(false, {
    name: 'AdminLandingPage',
    pathname: location.pathname
  });

  const tabs = getTabs(showBatchOperations);

  return (
    <AnimatedDiv>
      <StyledContainerWithColor {...otherProps} color={BINDER_COLOR}>
        <Layout>
          <BinderContentLeft>
            <BinderInformation
              {...{
                binderInformation: {
                  name: BINDER_NAME,
                  type: 'admin',
                  description: 'desc',
                  iconPath: '',
                  createdDate: '',
                  location: { address: '' }
                },
                isBinderPanelOpen: rightPanelOpen,
                toggleTabsMenu,
                loading: false
              }}
            />
          </BinderContentLeft>
          <BinderContentRight>
            <PageHeader>
              <Heading1 loading={false} label="Register" />
            </PageHeader>
            <ContentRegister>
              <RegisterCards>
                {tabs.map((tab, key) => {
                  return (
                    <Link key={key} to={`/tab/${tab.id}`}>
                      <Card
                        showCheckbox={false}
                        label={tab.name}
                        key={key}
                        showIcon={false}
                      />
                    </Link>
                  );
                })}
              </RegisterCards>
            </ContentRegister>
          </BinderContentRight>
        </Layout>
      </StyledContainerWithColor>
    </AnimatedDiv>
  );
};

export default AdminLandingPage;
